import { render, staticRenderFns } from "./Spectacle.vue?vue&type=template&id=42c837dc&scoped=true&"
import script from "./Spectacle.vue?vue&type=script&lang=ts&"
export * from "./Spectacle.vue?vue&type=script&lang=ts&"
import style0 from "./Spectacle.vue?vue&type=style&index=0&id=42c837dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c837dc",
  null
  
)

export default component.exports